//integracion de firestore en el proyecto
import { createStore, combineReducers, compose } from 'redux';
import { reactReduxFirebase, firebaseReducer } from 'react-redux-firebase';
import { reduxFirestore, firestoreReducer } from 'redux-firestore';
import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';
import 'firebase/storage'

// configurar firestore
const firebaseConfig = {
    apiKey: "AIzaSyAeohuMewoR3X9VqMrAbjrRa4am0QJLMaE",
    authDomain: "tour-di-viaggio.firebaseapp.com",
    projectId: "tour-di-viaggio",
    storageBucket: "tour-di-viaggio.appspot.com",
    messagingSenderId: "44769466519",
    appId: "1:44769466519:web:fab0ddcf7c043d59d5b1d2",
    measurementId: "G-61F5T3H8LY"
}

//configuracion de react-redux
const rrfConfig = {
    userProfile: 'users',
    useFirestoreForProfile: true
}

// inicializar firebase
firebase.initializeApp(firebaseConfig);

// Initialize other services on firebase instance
firebase.firestore() // <- needed if using firestore

// Reducers
const rootReducer = combineReducers({
    firebase: firebaseReducer,
    firestore: firestoreReducer
})

// crear el anlace con compose de redux y firestore
const createStoreWithFirebase = compose(
    reactReduxFirebase(firebase, rrfConfig),
    reduxFirestore(firebase)
)(createStore);

// state inicial
const initialState = {};

//crear el store
const store = createStoreWithFirebase(rootReducer, initialState)


export default store;